module.exports = __webpack_public_path__ + "img/logo-512.447d631e.png";